export const buildEventQuery = (rawQuery = {}, region) => {
  return {
    ...rawQuery,
    region: rawQuery.region ?? region,
  }
}



// WEBPACK FOOTER //
// ./src/modules/events/domain/utils/query.js